// Logos
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_web-page-23/artifacts/hzf0urqv_image.png"; // usar en toda la pag
export const LOGO_FORENSE =
  "https://customer-assets.emergentagent.com/job_web-page-23/artifacts/w6ck25z9_image.png"; // solo Psicologia Forense
export const LOGO_BLACK = LOGO_FORENSE; // compat retro

// Contacto principal (Katia)
export const WHATSAPP_NUMBER = "527295670431";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hola Psychelibrium, quisiera agendar una sesión / recibir información.",
)}`;

// Especialistas
export const WHATSAPP_KATIA = `https://wa.me/527295670431?text=${encodeURIComponent(
  "Hola Mtra. Katia, quisiera agendar una sesión con usted.",
)}`;
export const WHATSAPP_GERARDO = `https://wa.me/525544842443?text=${encodeURIComponent(
  "Hola Mtro. Gerardo, quisiera agendar una sesión con usted.",
)}`;

// Peritaje forense
export const WHATSAPP_FORENSE = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hola Psychelibrium, requiero información sobre peritaje forense / dictamen.",
)}`;

export const CONTACT_EMAIL = "psychelibrium@gmail.com";

// Redes sociales
export const INSTAGRAM_URL = "https://www.instagram.com/psychelibrium/";
export const FACEBOOK_URL =
  "https://www.facebook.com/profile.php?id=61571757748086";
export const YOUTUBE_URL = "https://www.youtube.com/@Psychelibrium";

export const NAV_ITEMS = [
  { to: "/nosotros", label: "Nosotros" },
  { to: "/servicios", label: "Servicios" },
  { to: "/especialistas", label: "Especialistas" },
  { to: "/colecciones", label: "Publicaciones" },
  { to: "/enfoques", label: "Enfoques Terapéuticos" },
  { to: "/psicologia-forense", label: "Psicología Forense" },
  { to: "/cuestionario", label: "Cuestionario" },
  { to: "/contacto", label: "Contacto" },
];
